import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8267a1dc&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8267a1dc')) {
      api.createRecord('8267a1dc', component.options)
    } else {
      api.reload('8267a1dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8267a1dc&", function () {
      api.rerender('8267a1dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/frame/html/index.vue"
export default component.exports